
import { batch } from 'react-redux';

import { queryClient } from '../state/queryClient';
import { addEltHistory } from '../state/reactquery';
import { store , modifyQualiflead , initialiseLeadappelant } from '../state/redux';

import { axios_clients_searchclientbytel } from '../axios/axios_clients';
import { phone , raccrocher_twilio} from './twilio';
import { simpleSDK } from "../utils/ringover";
import {  phonesend} from './aircall';
import { axios_notifs_addnotif } from '../axios/axios_notifs';

import { phonesip } from './siptel';



export const handlephone = async(numtel) =>{
      const user= queryClient.getQueryData(['user',localStorage.getItem('token')]);
      addEltHistory(store.getState().lead.leadactu.id,'appelsortant',  `<div class='horoline1' >Appel sortant</div>` ) ;
      batch( () => {  
        !store.getState().lead.leadactu.statut_client?.includes('gagne') && store.dispatch(modifyQualiflead(false));
      }) ;
    // user.type_tel === 'twilio' && store.dispatch(modifyPopupmultitel(true)) ; 
    user.type_tel === 'twilio' &&  phone(numtel) ; 
    user.type_tel === 'aircall' &&  phonesend(numtel) ; 
    user.type_tel === 'aircall' && document.getElementById('aircallphone').classList.remove('displaynone') ;
    user.type_tel === 'ringover' && simpleSDK.dial(numtel);	
    user.email === 'monsieursellam@gmail.com' && phonesip(numtel) ;
  }


  export const finappel = ()=>{
    const user= queryClient.getQueryData(['user',localStorage.getItem('token')]);
    user.type_tel === 'twilio' &&  raccrocher_twilio() ; 
}



export const findclientfromtel = async (numtel) => {
  let leadappelentrant;
  const user = queryClient.getQueryData(['user', localStorage.getItem('token')]);
  const response = await axios_clients_searchclientbytel({numtel,commercial:user['nom'],courtier:user['courtier']}) ;
  if (response.data.id === undefined) { leadappelentrant = {} }
  else { leadappelentrant = response.data }
  store.dispatch(initialiseLeadappelant(leadappelentrant));

  const newnotif = leadappelentrant.id ?{id_lead:leadappelentrant.id,notification:`Appelentrant<span>${store.getState().tel.messagetel}</span><span>${leadappelentrant.nom}</span><span>${leadappelentrant.prenom}</span>`,postmail:user?.postmail,type_notif:'appelentrant'}:
                  {notification:`Appelentrant<span>${store.getState().tel.messagetel}</span>`,postmail:user?.postmail,type_notif:'appelentrant'} ;
  
  await axios_notifs_addnotif(newnotif) ;
  queryClient.invalidateQueries({ queryKey: ['notifs']}) ;     

  return leadappelentrant.id
}

